module.exports = __webpack_public_path__ + "static/img/2017.8b10a65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/huaiBrand/2017.png
// module id = GVY6
// module chunks = 0